// extracted by mini-css-extract-plugin
export var md = "_2v-4";
export var semantic = "_2v-5";
export var sm = "_2v-3";
export var text = "_2v-6";
export var toggleInput = "_2v-0";
export var toggleSwitch = "_2v-1";
export var xs = "_2v-2";